// @flow
import * as React from "react"
import styled from "styled-components"
import JsCookies from "js-cookie"
import { connect } from "react-redux"

import cuckoo from "../../services/cuckoo/cuckoo"
import { setCookiesHeight as _setCookiesHeight } from "./services/actions"
import isEurope from "./services/continents"
import { getContinents } from "../../services/staticData/index"
import type { Continents } from "../../records/Continent"
import { isMobileSelector } from "../../services/window/index"
import CookiesScroller from "./CookiesScroller"
import { isKiwiBrandingSelector } from "common/services/branding/selectors"
import { MODALS } from "../../../mmb/consts/booking"
import Booking from "../../../../app/scripts/containers/mutable/Booking"

const CookiesConsentContainer = styled.div`
  ${({ hidden }: { hidden: boolean }) => hidden && "display: none;"};

  body.sidenav-opened & {
    display: none;
  }
`

type Props = {
  country: string,
  continents: Continents,
  smartFAQ: {
    open: boolean,
  },
  sideNav: {
    open: boolean,
  },
  helpCenter: {
    open: boolean,
  },
  isMobile: boolean,
  page: string,
  isSimpleLandingPage: boolean,
  setCookiesHeight: number => void,
  booking: Booking,
}

type State = {
  isAccepted: boolean,
  isShown: boolean,
}

class Cookies extends React.Component<Props, State> {
  state = {
    isAccepted: !(typeof window !== "undefined" && !JsCookies.get("cookie_consent")),
    isShown: true,
  }

  componentDidMount() {
    window.addEventListener("resize", this.updateHeight)
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateHeight)
  }

  setAccepted = () => {
    this.setState({ isAccepted: true })
    JsCookies.set("cookie_consent", "agreed", {
      ...window.Skypicker.cookieOptions,
      expires: 365 * 3,
    })
    cuckoo.infinario("cookieConsent", { status: "agreed" })
    this.props.setCookiesHeight(0)
  }

  node: ?HTMLDivElement

  updateHeight = () => {
    if (this.node) {
      const size = this.node.getBoundingClientRect()
      if (size.height > 0) {
        this.props.setCookiesHeight(size.height)
      }
    }
  }

  refCallback = (element: ?HTMLDivElement) => {
    if (element) {
      this.node = element
      // height is 0 at this time, need to wait to render the content probably
      setTimeout(() => this.updateHeight(), 100)
    }
  }

  isSearch = (page: string) => ["search", "topRoutes", "flight"].includes(page)

  render = () => {
    const {
      country,
      continents,
      sideNav,
      helpCenter,
      smartFAQ,
      isSimpleLandingPage,
      isMobile,
      page,
      booking,
    } = this.props
    const { isShown, isAccepted } = this.state

    const bookingModal = booking && booking.modal
    const isPaxAtaOpen = bookingModal === MODALS.PASSENGER_ATA

    const isHidden = sideNav.open || helpCenter.open || smartFAQ.open || !isShown || isPaxAtaOpen

    if (isAccepted || !isEurope(country, continents)) return ""

    return (
      <CookiesConsentContainer
        ref={this.refCallback}
        hidden={isHidden}
        search={this.isSearch(page) && !isSimpleLandingPage}
      >
        <CookiesScroller
          page={page}
          isSimpleLandingPage={isSimpleLandingPage}
          isSearch={this.isSearch}
          setAccepted={this.setAccepted}
          isMobile={isMobile}
        />
      </CookiesConsentContainer>
    )
  }
}

// $FlowFixMe TODO: plz add type when updating
export default connect(
  state => ({
    country: state.options.get("country"),
    continents: getContinents(state),
    smartFAQ: state.smartFAQ.widget,
    sideNav: state.sideNav,
    helpCenter: state.helpCenter.widget,
    isMobile: isMobileSelector(state),
    page: state.page.get("name"),
    isSimpleLandingPage: state.options.isRootPage && isKiwiBrandingSelector(state),
  }),
  dispatch => ({
    setCookiesHeight: height => dispatch(_setCookiesHeight(height)),
  }),
)(Cookies)
